import { Controller } from "@hotwired/stimulus"

// Formulari de plantació: recarrega el frame «official_plot» amb la clau
// SIGPAC completa (municipi, agregat, zona, polígon, parcel·la i recinte).
export default class extends Controller {
  static targets = ["frame", "field"]
  static values = { url: String }

  check() {
    const url = new URL(this.urlValue, window.location.origin)
    for (const field of this.fieldTargets) {
      if (field.value === "") return
      url.searchParams.set(field.dataset.key, field.value)
    }
    this.frameTarget.src = url.toString()
  }
}
